import { CartUpdateEvent } from '@theme/events';

class CCQuickBuy extends HTMLElement {
  static queue = Promise.resolve();

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.form = this.querySelector('form');
    this.quantity = this.querySelector('[name="quantity"]');
    this.variant = this.querySelector('[name="id"]');
    this.submit = this.querySelector('[type="submit"]');
    this.status = this.querySelector('[role="status"]');
    this.addEventListener('click', (event) => {
      event.stopPropagation();
      const button = event.target.closest('[data-quantity-change]');
      if (!button || button.disabled) return;
      const min = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      const max = this.quantity.max === '' ? Infinity : Number(this.quantity.max);
      const value = Math.max(min, Number(this.quantity.value) || min);
      const direction = Number(button.dataset.quantityChange);
      this.quantity.value = String(Math.min(max, Math.max(min, value + direction * step)));
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.variant.addEventListener('change', () => {
      const option = this.variant.selectedOptions?.[0];
      if (!option?.value) return;
      this.quantity.min = option.dataset.min || '1';
      this.quantity.step = option.dataset.step || '1';
      this.quantity.max = option.dataset.max || '';
      this.quantity.value = this.quantity.min;
      this.status.textContent = '';
      this.removeAttribute('data-state');
    });
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.pending || !this.form.reportValidity()) return;
      const id = this.variant.value;
      const quantity = Number(this.quantity.value);
      if (!id || !Number.isInteger(quantity) || quantity < 1) return;
      this.pending = true;
      this.submit.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      this.removeAttribute('data-state');
      const operation = CCQuickBuy.queue.then(() => this.addItem(id, quantity));
      CCQuickBuy.queue = operation.catch(() => {});
      operation.finally(() => {
        this.pending = false;
        this.submit.disabled = false;
        this.removeAttribute('aria-busy');
      });
    });
  }

  async addItem(id, quantity) {
    const root = window.Shopify?.routes?.root || '/';
    const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]'), (element) => element.dataset.sectionId))].slice(0, 5);
    let result;
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }], sections, sections_url: location.pathname }),
      });
      result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
      }
    } catch (error) {
      this.dataset.state = 'error';
      this.status.textContent = error instanceof TypeError ? this.dataset.error : error.message || this.dataset.error;
      return;
    }
    let cart;
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (response.ok) cart = await response.json();
    } catch {}
    document.dispatchEvent(new CartUpdateEvent(cart || result, `cc-quick-buy-${this.dataset.productId}`, {
      source: cart ? 'cc-quick-buy' : 'product-form-component',
      ccQuickBuy: true,
      productId: this.dataset.productId,
      variantId: id,
      itemCount: cart ? cart.item_count : quantity,
      sections: result.sections,
    }));
    this.dataset.state = 'success';
    this.status.textContent = this.dataset.added.replace('__quantity__', String(quantity));
  }
}

if (!customElements.get('cc-quick-buy')) customElements.define('cc-quick-buy', CCQuickBuy);